"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4,
} from "../../../../../../public/images/blogs/constructionDrawing";

export default function BlogContent() {
  const t = useTranslations("blogs.constructionDrawing");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link1: (chunk) => (
              <a
                href="https://dejure.org/gesetze/BauPruefVO/4.html"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary font-bold transition-all"
              >
                {chunk}
              </a>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link1: (chunk) => (
              <BlogLink href="/blog/bebauungsplan">{chunk}</BlogLink>
            ),
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
            link1: (chunk) => (
              <BlogLink href="/blog/schnitte-und-ansichten">{chunk}</BlogLink>
            ),
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
        />
        <Content
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
            link1: (chunk) => (
              <BlogLink href="/blog/grundriss-zeichnen-per-hand">
                {chunk}
              </BlogLink>
            ),
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
          imageLeft={true}
          disclaimer="legal"
        />
      </div>
    </>
  );
}
